import { Injectable } from '@angular/core';
import { Router, UrlTree } from '@angular/router';
import { RolePermission, RolePermissionService } from '../auth/rbac/role-permission.service';

/** Route gate for AI settings. Opening the page requires AI_SETTING_MANAGE, not just AI_INSIGHT_READ. */
@Injectable()
export class AiSettingsAccessGuard {
  constructor(
    private permissions: RolePermissionService,
    private router: Router,
  ) {}

  canActivate(): boolean | UrlTree {
    if (this.permissions.hasPermissions([RolePermission.AI_SETTING_MANAGE])) {
      return true;
    }
    return this.router.parseUrl('/forbidden');
  }
}
